import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, cardCls } from "@/components/mobile/parts";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

const SECTIONS = [
  ["Quais dados o app usa", "O app de comandas usa os dados da conta da sua empresa no FSCsistemas: usuários, comandas, mesas, produtos, clientes cadastrados (nome e telefone), pedidos, vendas e pagamentos. São os mesmos dados do sistema completo."],
  ["Para que os dados são usados", "Somente para operar o atendimento: abrir e fechar comandas, lançar pedidos, imprimir comprovantes, aprovar cancelamentos e descontos e gerar os relatórios da empresa."],
  ["Quem pode ver", "Apenas usuários da sua empresa, com login e senha, e de acordo com o nível de acesso e as permissões definidas pelo administrador. Cada empresa só enxerga os próprios dados."],
  ["Dados guardados no celular", "Para funcionar sem internet, o app guarda neste aparelho uma cópia do cardápio, das comandas abertas e dos pedidos que ainda não foram enviados. Esses dados são apagados ao enviar os pedidos ou em Configurações → Apagar dados guardados no celular."],
  ["Segurança", "O acesso é protegido por número de acesso, login e senha, com bloqueio após tentativas erradas e sessões que podem ser encerradas pelo administrador. Ações como cancelamentos e descontos ficam registradas no histórico."],
  ["Seus direitos", "Pedidos de consulta, correção ou exclusão de dados pessoais devem ser feitos ao responsável pela empresa, que pode contar com o suporte do FSCsistemas (menu Suporte e Atendimento)."],
];

export default function MPrivacy() {
  const { session } = useAuth();
  return (
    <>
      <MTopBar title="Política de privacidade" back />
      <MPage>
        <p className="text-sm text-slate-500">Como o app de comandas da {session.tenant.nome_fantasia} trata as informações.</p>
        {SECTIONS.map(([t, txt]) => (
          <section key={t} className={cn(cardCls, "space-y-1 p-4")}>
            <h2 className="font-display text-base font-semibold">{t}</h2>
            <p className="text-sm leading-relaxed text-slate-600">{txt}</p>
          </section>
        ))}
      </MPage>
    </>
  );
}
